// Vollea — Settings (logout, version)
import React from "react";
import { useNavigate } from "react-router-dom";
import { IoChevronBack, IoLogOutOutline, IoShieldOutline } from "react-icons/io5";
import { Card } from "../components/ui-vollea";
import { useAuth } from "../contexts/AuthContext";
import { C, SP, R } from "../lib/theme";

export default function Settings() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const isSuper = user?.role === "super_admin";

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div style={{ background: C.bg, minHeight: "100vh", padding: `${SP.lg}px ${SP.lg}px 90px` }}>
      <button onClick={() => navigate(-1)} data-testid="settings-back" style={{ color: C.text, marginBottom: SP.md }}>
        <IoChevronBack size={26} />
      </button>
      <h1 style={{ color: C.text, fontWeight: 700, fontSize: 28, margin: 0, letterSpacing: 0.5 }}>Settings</h1>

      <div style={{ marginTop: SP.xl, display: "flex", flexDirection: "column", gap: SP.md }}>
        {isSuper && (
          <Card onClick={() => navigate("/admin")} testid="settings-admin-link">
            <div style={{ display: "flex", alignItems: "center", gap: SP.md }}>
              <div style={{ width: 40, height: 40, borderRadius: R.md, background: C.limeTint, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <IoShieldOutline size={20} color={C.lime} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ color: C.text, fontWeight: 700, fontSize: 15 }}>Super Admin</div>
                <div style={{ color: C.textMuted, fontSize: 13 }}>Manage invites, feedback, stats</div>
              </div>
            </div>
          </Card>
        )}

        <button onClick={handleLogout} data-testid="settings-logout-btn" style={{ width: "100%", height: 52, borderRadius: R.md, border: `1px solid ${C.borderStrong}`, color: C.error, fontWeight: 700, fontSize: 14, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, letterSpacing: 1, textTransform: "uppercase" }}>
          <IoLogOutOutline size={18} /> Log out
        </button>
      </div>

      <div style={{ marginTop: SP.xxl, textAlign: "center" }}>
        <div style={{ color: C.textDim, fontSize: 11, letterSpacing: 1 }}>VOLLEA WEB · Closed Beta</div>
      </div>
    </div>
  );
}
